import(/* webpackMode: "eager" */ "/app/apps/website/public/static/images/contact/calendar.png");
;
import(/* webpackMode: "eager" */ "/app/apps/website/public/static/images/contact/contact.webp");
;
import(/* webpackMode: "eager" */ "/app/apps/website/public/static/images/contact/globe.webp");
;
import(/* webpackMode: "eager" */ "/app/apps/website/public/static/images/contact/mail.png");
;
import(/* webpackMode: "eager" */ "/app/apps/website/public/static/images/contact/phone.png");
;
import(/* webpackMode: "eager", webpackExports: ["ContactForm"] */ "/app/apps/website/src/app/(rootLayout)/contact/_components/contact-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
